<div class="wrapper">
  <div class="search-container">
    <div class="search-bar" >
      @if (searchControl.value) {
        <button mat-icon-button (click)="clearSearch()"> <mat-icon>arrow_back</mat-icon> </button>
      }
      @else {
        <mat-icon class="icon-container">search</mat-icon>
      }
      <input [formControl]="searchControl" name="search_query" autocomplete="off" autocorrect="off" spellcheck="false">
      <button mat-icon-button (click)="openFilters()"> <mat-icon>filter_list</mat-icon> </button>

    </div>

    @if (!downloading() && (roleService.can('update','check_in') | async)) {
      <button mat-icon-button (click)="openDateRange()"><mat-icon>download</mat-icon></button>
    }
    @if (downloading()) {
      <button mat-icon-button disabled><mat-icon>downloading</mat-icon></button>
    }
  </div>


  <div class="statuses-container hide-mobile">
    @for (status of statuses; track status.id) {
      <div class="status-box" (click)="toggleFilter(status.id)">
        <div class="status-content">
          <div class="checkbox-container" >
              @if (statusOn(status.id)) {
                <mat-icon [ngStyle]="{'color': status.color}" >check_box</mat-icon>
              }@else{
                <mat-icon class="default" [ngStyle]="{'color': status.color}">check_box_outline_blank</mat-icon>
                <mat-icon class="on-hover" [ngStyle]="{'color': status.color}">check_box_outline_blank</mat-icon>
              }
          </div>
          <div class="counter">
            <span class="default" [ngStyle]="{'color': status.color}">{{totalByStatus[status.id]?.count ?? 0}}</span>
            <span class="on-hover" [ngStyle]="{'color': status.color}">{{totalByStatus[status.id]?.count ?? 0}}</span>
          </div>
          <div class="status-name">
            {{status.name}}
          </div>
        </div>
      </div>
    }
  </div>

  <div class="table-container display-desktop" id="orders"  appPagination (loadMore)="getMore()" [isLoading]="loadingMore()" [page]="page" [totalPages]="total_pages">
    <mat-card class="box-shadowless">
      <mat-card-content style="padding: 0;">
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)">

          <ng-container matColumnDef="correlative-id" >
            <th mat-header-cell *matHeaderCellDef> N° {{appService.getText('check_in')}} </th>
            <td mat-cell *matCellDef="let order"> #{{order.correlative_id}} </td>
          </ng-container>

          <ng-container matColumnDef="requirement-name">
            <th mat-header-cell *matHeaderCellDef> {{appService.getText('requirement')}} </th>
            <td mat-cell *matCellDef="let order"> {{order.requirement?.name}}  <i matTooltip="Este {{appService.getText('object')}} tiene un recall" class="fa fa-bullhorn" *ngIf="order.recall_data && order.recall_data.length > 0"></i> </td>
          </ng-container>

          <ng-container matColumnDef="object-identifier">
            <th mat-header-cell *matHeaderCellDef> {{appService.getText('object_identifier') || appService.getText('client_identifier') }} </th>
            <td mat-cell *matCellDef="let order">
              @if (roleService.can('read', 'vehicle') | async) {
                <span go-to-details [element]="order.object" type="Vehicle" class="link">
                  {{order.object?.identifier || '-'}}
                </span>
              } @else {
                <span>{{order.object?.identifier || '-'}}</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="client-name">
            <th mat-header-cell *matHeaderCellDef> {{appService.getText('client')}} </th>
            <td mat-cell *matCellDef="let order">
              @if (roleService.can('read', 'client') | async) {
                <span go-to-details [element]="order.client" type="Client" class="link">
                  {{ (order.client.name || '-') | titlecase}}
                </span>
              } @else {
                <span>{{ (order.client.name || '-') | titlecase}}</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="check_in_time" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Recepción </th>
            <td mat-cell *matCellDef="let order"> {{ order.check_in_time | date }} </td>
          </ng-container>

          <ng-container matColumnDef="status_id" >
            <th mat-header-cell *matHeaderCellDef> Estado </th>
            <td mat-cell *matCellDef="let order">
              <span class="status-container" [matTooltip]="order.status?.name || (order.status_id | status:'name': statuses)">
                <mat-icon
                  [style.color]="order.status?.id | status:'color'"
                >
                  circle
                </mat-icon>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let order">
              <button mat-icon-button (click)="openChat($event, order)" matTooltip="Abrir chat">
                <mat-icon class="icon-primary">chat</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" [routerLink]="['/main', 'orders', row.id]" [hidden]="working()"></tr>
        </table>

        <div class="empty" [hidden]="!working()">
          <mat-spinner></mat-spinner>
        </div>

        @if (orders && orders.length == 0 && !working()) {
          <div class="empty white-rounded">
            <span>No se han encontrado {{'order' | human: 'lowercase': null: 'plural'}}</span>
          </div>
        }

        <div class="load-more white-rounded" [hidden]="page >= total_pages" id="load-more">
          <mat-spinner [diameter]="20"></mat-spinner> Cargando {{'order' | human: 'lowercase': null: 'plural'}}...
        </div>

      </mat-card-content>
    </mat-card>
  </div>



  <div class="table-container display-mobile scroll-shadows" id="orders" appPagination (loadMore)="getMore()" [isLoading]="loadingMore()" [page]="page" [totalPages]="total_pages">

    <div class="card" *ngFor="let order of orders;" [routerLink]="['/main', 'orders', order.id]" [hidden]="working()">
      <div class="card-content">
        <div class="card-image" *ngIf="order.order_attachments && order.order_attachments.length > 0" [ngStyle]="{'background-image': 'url(' + getThumbUrl(order.order_attachments[0])+ ')'}"></div>
        <div class="card-details">
          <div class="row no-margin">
            <span class="small light">#{{order.correlative_id}}</span>
            <div class="expander"></div>
            <button mat-icon-button (click)="openChat($event, order)" matTooltip="Abrir chat">
              <mat-icon class="icon-primary">chat</mat-icon>
            </button>
          </div>
          <div class="row title">
            <span class="bold">{{order.object?.identifier || (order.client?.rut | identifier)}}</span>
            <span class="light">{{order.requirement?.name}} <i matTooltip="Este {{appService.getText('object')}} tiene un recall" class="fa fa-bullhorn" *ngIf="order.recall_data && order.recall_data.length > 0"></i>
             </span>
          </div>
          <div class="row">
            <span go-to-details [element]="order.client" type="Client" class="link">{{order.client.name}}</span>
          </div>
          <div class="row">
            <span class="status-container">
              <mat-icon [style.color]="order.status?.id | status:'color'">circle</mat-icon>
              &nbsp;{{order.status?.name}}
            </span>
          </div>
        </div>
      </div>
    </div>


    @if (orders && orders.length == 0 && !working()) {
      <div class="empty">
        <span>No se han encontrado {{'order' | human: 'lowercase': null: 'plural'}}</span>
      </div>
    }

    <div class="load-more" [hidden]="page >= total_pages" id="load-more">
      <mat-spinner [diameter]="20"></mat-spinner> Cargando {{'order' | human: 'lowercase': null: 'plural'}}...
    </div>

    <div class="loading" [hidden]="!working()">
      <mat-spinner></mat-spinner>
    </div>


  </div>


</div>
